import React, { useState } from 'react';
import { FloatButton, Popover, Radio } from 'antd';
import {
  DashboardOutlined,
  CommentOutlined,
  AlertOutlined,
  RadarChartOutlined,
  FilterOutlined
} from '@ant-design/icons';
import { BsFeather } from 'react-icons/bs';
import { MdLayers } from 'react-icons/md';
import MapControl from './MapControl';

const LAYERS = [
  { value: 'streets', label: 'Street Map' },
  { value: 'satellite', label: 'Satellite' },
];

export default function MapControls({
  // permisos / visibilidad
  canViewHistorical,
  isComplaintView,
  isIncidentView,
  canViewComplaints,
  canViewIncidents,

  // estados
  viewMode,
  showComplaints,
  showIncidents,
  plumePanelVisible,
  filterComplaintsOpen,
  filterIncidentsOpen,

  // setters / handlers
  setViewMode,
  onOpenComplaintsFilter,
  onOpenIncidentsFilter,
  onToggleComplaints,
  onToggleIncidents,
  setShowRoseMenu,
  centerMap,
  cleanUpPlume,
  togglePlumeMode,
  plumeMode,

  mapLayer,
  setMapLayer

}) {
  const [layerPopoverOpen, setLayerPopoverOpen] = useState(false);

  // if (isComplaintView) return null;

  const layerContent = (
    <Radio.Group
      value={mapLayer}
      onChange={e => { setMapLayer(e.target.value); setLayerPopoverOpen(false); }}
      style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
    >
      {LAYERS.map(l => (
        <Radio key={l.value} value={l.value}>{l.label}</Radio>
      ))}
    </Radio.Group>
  );

  return (
    <>
      {canViewHistorical && (
        <>
          {/* MODOS */}
          <MapControl position="topleft">
            <FloatButton.Group shape="square" direction="horizontal">
              <FloatButton
                className={viewMode === 'devices' ? 'map-button-active' : ''}
                icon={<DashboardOutlined style={{ color: viewMode === 'devices' ? 'white' : undefined }} />}
                tooltip={{ title: 'Devices', placement: 'bottom' }}
                onClick={() => {
                  setViewMode('devices');
                  setShowRoseMenu(false);
                  centerMap();
                }}
              />
              <FloatButton
                className={viewMode === 'roses' ? 'map-button-active' : ''}
                icon={<RadarChartOutlined style={{ color: viewMode === 'roses' ? 'white' : undefined }} />}
                tooltip={{ title: 'Pollution rose', placement: 'bottom' }}
                onClick={() => setShowRoseMenu(v => !v)}
              />
              <FloatButton
                className={plumePanelVisible ? 'map-button-active' : ''}
                icon={<BsFeather style={{ color: plumePanelVisible ? 'white' : undefined }} />}
                tooltip={{ title: 'Plume', placement: 'bottom' }}
                onClick={() => {
                  cleanUpPlume();
                  togglePlumeMode();
                }}
              />
            </FloatButton.Group>
          </MapControl>
        </>
      )}

      {canViewComplaints && (
        <>
          {/* COMPLAINTS */}
          <MapControl position="topleft">
            <FloatButton.Group shape="square" direction="horizontal">
              <FloatButton
                className={showComplaints ? 'map-button-active' : ''}
                icon={<CommentOutlined style={{ color: showComplaints ? 'white' : undefined }} />}
                tooltip={{ title: showComplaints ? 'Hide complaints' : 'Show complaints', placement: 'bottom' }}
                onClick={onToggleComplaints}
              />

              {showComplaints && (
                <FloatButton
                  className={filterComplaintsOpen ? 'map-button-filter-open' : ''}
                  icon={<FilterOutlined />}
                  tooltip={{ title: 'Filter complaints', placement: 'bottom' }}
                  onClick={onOpenComplaintsFilter}
                />
              )}
            </FloatButton.Group>
          </MapControl>
        </>
      )}

      {canViewIncidents && (
        <>
          {/* INCIDENTS */}
          <MapControl position="topleft">
            <FloatButton.Group shape="square" direction="horizontal">
              <FloatButton
                className={showIncidents ? 'map-button-active' : ''}
                icon={<AlertOutlined style={{ color: showIncidents ? 'white' : undefined }} />}
                tooltip={{ title: showIncidents ? 'Hide incidents' : 'Show incidents', placement: 'bottom' }}
                onClick={onToggleIncidents}
              />

              {showIncidents && (
                <FloatButton
                  className={filterIncidentsOpen ? 'map-button-filter-open' : ''}
                  icon={<FilterOutlined />}
                  tooltip={{ title: 'Filter incidents', placement: 'bottom' }}
                  onClick={onOpenIncidentsFilter}
                />
              )}
            </FloatButton.Group>
          </MapControl>
        </>
      )}
      {/* SELECTOR DE CAPAS */}
      <MapControl position="topleft">
        <Popover
          open={layerPopoverOpen}
          onOpenChange={setLayerPopoverOpen}
          content={layerContent}
          title="Map layers"
          trigger="hover"
          placement="bottom"
          mouseLeaveDelay={0.3}
        >
          <button className='layer-picker-btn'>
            <span className='layer-picker-btn-body'>
              <MdLayers size={18} />
            </span>
          </button>
        </Popover>
      </MapControl>
    </>
  );
}
